export function maybePrepend(prepend, append) {
  return `${prepend ? `${prepend} ` : ''}${append}`;
}

export function bifurcate(before, middle, after) {
  return `${before} ${middle ? `${middle} ` : ''}${after}`;
}
